// extracted by mini-css-extract-plugin
module.exports = {"main":"forgotPassword_main__7GR4Y","one_line":"forgotPassword_one_line__S_agr","error":"forgotPassword_error__3vWyH","password":"forgotPassword_password__KRHtG"};